import React, { Fragment } from "react"
import PropTypes from "prop-types"
import { List } from "antd"
import { truncate } from "lodash"
import ModalDeleteSimple from "../../../ModalDeleteSimple"
import { MinusCircleFilled } from "@ant-design/icons"

class CompanyUserAccessListItem extends React.Component {
  state = {
    openModal: false,
    tempItem: [],
  }

  submitButton = (item) => {
    const { isNew } = this.props
    ;(async () => {
      if (isNew) this.submit(item)
      if (!isNew) await this.setState({ openModal: true, tempItem: item })
    })()
  }

  submit = (item) => {
    this.setState({ openModal: false })
    this.props.removeItem(item)
  }

  render() {
    const checkUndefined = this.props.dataSource == null

    const checkExistData = checkUndefined
      ? false
      : this.props.dataSource.length > 0

    return (
      <div style={{ display: checkExistData === false ? "none" : "block" }}>
        <List
          className="listSubdivisions"
          size="small"
          loading={this.props.companiesAccessLoading}
          bordered
          style={{ maxHeight: 200, overflow: "auto" }}
          dataSource={this.props.dataSource}
          renderItem={(item) => (
            <List.Item>
              <span>{truncate(item.name, { length: 72 })}</span>
              <MinusCircleFilled onClick={() => this.submitButton(item)} />
            </List.Item>
          )}
        />
        <ModalDeleteSimple
          visible={this.state.openModal}
          content={
            <Fragment>
              <p>
                <b>
                  ¿Estás seguro de que deseas eliminar la empresa del listado?
                </b>
              </p>
              <br />
              <p>
                El Administrador ya no podrá acceder a la empresa ni visualizar
                su información.
              </p>
            </Fragment>
          }
          loading={this.props.companiesAccessLoading}
          onOk={() => this.submit(this.state.tempItem)}
          onCancel={() => this.setState({ openModal: false })}
        />
      </div>
    )
  }
}

CompanyUserAccessListItem.propTypes = {
  isNew: PropTypes.bool,
  companiesAccessLoading: PropTypes.bool,
  dataSource: PropTypes.array,
  removeItem: PropTypes.func.isRequired,
}

export default CompanyUserAccessListItem
